import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Spinner } from 'react-bootstrap';
import { ForgotPasswordRequest } from '../../_core/_request.ts'; // Adjust path as needed

const ForgetPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');
    setMessage('');

    try {
      const response = await ForgotPasswordRequest({ Email: email });
      setStatus('success');
      setMessage(response.data.message || 'If an account matches that email, a password reset link has been sent.');
    } catch (err: any) {
      setStatus('error');
      setMessage(err.response?.data || 'An error occurred while requesting a password reset.');
    }
  };

  const variants = {
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0 }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
      <motion.div
        className="card shadow p-4 w-100"
        style={{ maxWidth: '500px' }}
        initial="initial"
        animate="animate"
        variants={variants}
        transition={{ duration: 0.4 }}
      >
        <div className="card-body d-flex flex-column gap-3">
          <h2 className="card-title text-center text-primary mb-2">Reset Password</h2>
          
          {status === 'success' ? (
            <div className="text-center">
              <div className="alert alert-success">{message}</div>
              <p className="text-muted mt-3">Please check your email inbox and spam folder.</p>
              <button className="btn btn-outline-primary mt-2" onClick={() => navigate('/login')}>
                Return to Login
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="d-flex flex-column gap-3">
              <p className="text-muted text-center mb-2">
                Enter your email address and we'll send you a link to reset your password.
              </p>
              
              <div>
                <label className="form-label">Email Address</label>
                <input
                  aria-label="email"
                  type="email"
                  className="form-control"
                  value={email}
                  required
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={status === 'loading'}
                />
              </div>

              {status === 'error' && <div className="text-danger small">{message}</div>}

              <button className="btn btn-primary mt-2" type="submit" disabled={status === 'loading' || !email}>
                {status === 'loading' ? (
                  <span><Spinner animation="border" size="sm" className="me-2" />Sending...</span>
                ) : (
                  'Send Reset Link'
                )}
              </button>
              
              <div className="text-center mt-3">
                <Link to="/login" className="text-decoration-none">Back to Login</Link>
              </div>
            </form>
          )}
        </div>
      </motion.div>
    </div>
  );
};

export default ForgetPassword;